import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { FC } from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';
import { PageContainer } from '../PageContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
    microfrontendsRegistry,
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <MicrofrontendProvider registry={microfrontendsRegistry}>
            <Provider store={reduxStore}>
              <PageContainer />
            </Provider>
          </MicrofrontendProvider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
